import { IconButton, Slider, styled } from "@mui/material";
import { VolumeOff, VolumeUp } from "@mui/icons-material";

const VolumeSlider = styled(Slider)({
  color: "#239B8B",
  height: 2,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 14,
    width: 14,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
});

interface VolumeControlProps {
  isMuted: boolean;
  volume: number;
  handleMute: () => void;
  handleVolume: (event: Event, value: number | number[], activeThumb: number) => void;
  handleVolumeSeekDown: (event: Event | React.SyntheticEvent<Element, Event>, value: number | number[]) => void;
}

const VolumeControl = ({ isMuted, volume, handleMute, handleVolume, handleVolumeSeekDown }: VolumeControlProps) => (
  <>
    <IconButton aria-label="volume" onClick={handleMute} sx={{ ":focus": { outline: "none" } }}>
      {isMuted ? (
        <VolumeOff sx={{ color: "white", fontSize: "20px !important" }} />
      ) : (
        <VolumeUp sx={{ color: "white", fontSize: "20px !important" }} />
      )}
    </IconButton>
    <VolumeSlider
      min={0}
      max={100}
      aria-label="volumen slider"
      value={volume * 100}
      onChange={handleVolume}
      onChangeCommitted={handleVolumeSeekDown}
    />
  </>
);

export default VolumeControl;
